export default __webpack_public_path__ + "static/media/sponsor.d6f538a9.jpg";